"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = Modal;
exports.ModalContents = ModalContents;
exports.ModalDismissButton = ModalDismissButton;
exports.ModalOpenButton = ModalOpenButton;
var _react = require("@emotion/react");
var _lib = require("./lib");
var _visuallyHidden = require("@reach/visually-hidden");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /** @jsx jsx */ // import {Dialog} from '@reach/dialog'
const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(args));
const ModalContext = /*#__PURE__*/React.createContext();
function Modal(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  return (0, _react.jsx)(ModalContext.Provider, _extends({
    value: [isOpen, setIsOpen]
  }, props));
}
function ModalOpenButton({
  children
}) {
  const [, setIsOpen] = React.useContext(ModalContext);
  return /*#__PURE__*/React.cloneElement(children, {
    onClick: callAll(() => setIsOpen(true), children.props.onClick)
  });
}
function ModalContentsBase(props) {
  const [isOpen, setIsOpen] = React.useContext(ModalContext);
  return (0, _react.jsx)(_lib.Dialog, _extends({
    isOpen: isOpen,
    onDismiss: () => setIsOpen(false)
  }, props));
}
function ModalDismissButton({
  children: child,
  ...props
}) {
  const [, setIsOpen] = React.useContext(ModalContext);
  return /*#__PURE__*/React.cloneElement(child, {
    onClick: callAll(() => setIsOpen(false), child.props.onClick)
  });
}
function ModalContents(props) {
  return (0, _react.jsx)(ModalContentsBase, null, (0, _react.jsx)("div", {
    css: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, (0, _react.jsx)(ModalDismissButton, null, (0, _react.jsx)(_lib.CircleButton, null, (0, _react.jsx)(_visuallyHidden.VisuallyHidden, null, "Close"), (0, _react.jsx)("span", {
    "aria-hidden": true
  }, "X")))), (0, _react.jsx)("h3", {
    css: {
      textAlign: 'center',
      fontSize: '2em'
    }
  }, props.title), props.children);
}